import {AHT_KEY, AHT_TOKEN, AHT_TOKEN_LOCAL} from "../pages/login/static";


export function checkAuth(): boolean {
	const token = document.cookie?.split(';')
		?.find(cookie => cookie.indexOf(AHT_KEY + '=') !== -1)
		?.split('=')[1]
	return (
		 token === AHT_TOKEN || token === AHT_TOKEN_LOCAL
		|| false
	)
}
